// @module BTM.BRPersonalization.BRSuppressPersonalizationOption
define('BTM.BRPersonalization.BRSuppressPersonalizationOption.QuickView'
,	[
		'btm_brpersonalization_brsuppresspersonalizationoption_quickview.tpl'
	,	'Utils'
	,	'Backbone'
	,	'jQuery'
	,	'underscore'
	]
,	function (
		btm_brpersonalization_brsuppresspersonalizationoption_quickview_tpl
	,	Utils
	,	Backbone
	,	jQuery
	,	_
	)
{
	'use strict';

	// @class BTM.BRPersonalization.BRSuppressPersonalizationOption.View @extends Backbone.View
	return Backbone.View.extend({

		template: btm_brpersonalization_brsuppresspersonalizationoption_quickview_tpl

	,	initialize: function (options) {

			/*  Uncomment to test backend communication with an example service 
				(you'll need to deploy and activate the extension first)
			*/
			this.message = '';
			// var service_url = Utils.getAbsoluteUrl(getExtensionAssetsPath('services/BRSuppressPersonalizationOption.Service.ss'));

			// jQuery.get(service_url)
			// .then((result) => {

			// 	this.message = result;
			// 	this.render();
			// });
		}

	,	events: {
		}

	,	bindings: {
		}

	, 	childViews: {
			
		}

		//@method getContext @return BTM.BRPersonalization.BRSuppressPersonalizationOption.View.Context
	,	getContext: function getContext()
		{
			//@class BTM.BRPersonalization.BRSuppressPersonalizationOption.View.Context
			this.message = this.message || 'Hello World!!'
			return {
				message: this.message
			};
		}
	});
});
